export default "__VITE_ASSET__k0oH0wBa__"